<template>
  <div>
    <div class="bodyBox">
      <!--      <div class="cardBox">
              <div class="cardHead">当天</div>
              <el-divider></el-divider>
              <el-row :gutter="25" style="text-align:center;padding: 0 10px">
                <el-col :span="12">
                  <el-card shadow="hover">
                    <div>作业数量</div>
                    <h2>{{ day.total }}</h2>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card shadow="hover">
                    <div>合格率</div>
                    <h2 v-if="day.percentPass">{{ day.percentPass | toPercent }}</h2>
                    <h2 v-else>0.00%</h2>
                  </el-card>
                </el-col>
              </el-row>
      &lt;!&ndash;        <WorkPermitDay :item="dayList"></WorkPermitDay>&ndash;&gt;
            </div>
            <div class="cardBox">
              <div class="cardHead">当周</div>
              <el-divider></el-divider>
              <el-row :gutter="25" style="text-align:center;padding: 0 10px">
                <el-col :span="12">
                  <el-card shadow="hover">
                    <div>作业数量</div>
                    <h2>{{ week.total }}</h2>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card shadow="hover">
                    <div>合格率</div>
                    <h2 v-if="week.percentPass">{{ week.percentPass | toPercent }}</h2>
                    <h2 v-else>0.00%</h2>
                  </el-card>
                </el-col>
              </el-row>
            </div>-->
            <div class="cardBox">
<!--              <div class="cardHead">当月</div>
              <el-divider></el-divider>
              <el-row :gutter="25" style="text-align:center;padding: 0 10px">
                <el-col :span="12">
                  <el-card shadow="hover">
                    <div>作业数量</div>
                    <h2>{{ month.total }}</h2>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card shadow="hover">
                    <div>合格率</div>
                    <h2 v-if="month.percentPass">{{ month.percentPass | toPercent }}</h2>
                    <h2 v-else>0.00%</h2>
                  </el-card>
                </el-col>
              </el-row>-->
              <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                <el-form-item label="检查日期">
                  <el-date-picker
                      v-model="queryParams.gmtCreate"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      @change="gmtCreate">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSearch(queryParams)">查询</el-button>
                  <el-button @click="resetSearch">重置</el-button>
                </el-form-item>
              </el-form>
              <WorkPermitDay :item="yearList"></WorkPermitDay>
<!--              <WorkPermitMonth :item="monthList"></WorkPermitMonth>-->
            </div>
      <div class="cardBox">
        <div class="cardHead">当年</div>
        <el-divider></el-divider>
        <el-row :gutter="25" style="text-align:center;padding: 0 10px">
          <el-col :span="12">
            <el-card shadow="hover">
              <div>作业数量</div>
              <h2>{{ year.total }}</h2>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="hover">
              <div>合格率</div>
              <h2 v-if="year.percentPass">{{ year.percentPass | toPercent }}</h2>
              <h2 v-else>0.00%</h2>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import {getWorkInfo, qualifiedStatistics} from "@/api/processManager"
import WorkPermitDay from "@/dash/components/WorkPermitDay.vue";
import WorkPermitWeek from "@/dash/components/WorkPermitWeek.vue";
import WorkPermitMonth from "@/dash/components/WorkPermitMonth.vue";

export default {
  name: 'ProcessWorkStatistics',
  components: {
    WorkPermitDay,
    WorkPermitWeek,
    WorkPermitMonth
  },
  data() {
    return {
      day: {},
      week: {},
      month: {},
      year: {},
      dayList: [],
      weekList: [],
      monthList: [
        {
          count: 5,
          name: "动火作业",
        },
        {
          name: "动火作业",
          count: 2
        },
        {
          name: "动火作业",
          count: 3
        },
        {
          name: "动火作业",
          count: 4
        },
        {
          name: "动火作业",
          count: 5
        },
        {
          name: "动火作业",
          count: 6
        },
        {
          name: "动火作业",
          count: 7
        },
        {
          name: "动火作业",
          count: 8
        }
      ],
      yearList: [],
      queryParams: {
        planStartTime: null,
        planEndTime: null
      }
    }
  },
  filters: {
    toPercent(val) {
      let str = Number(val * 100).toFixed(2);
      str += "%";
      return str;
    }
  },
  created() {
   /* getWorkInfo({type: 1}).then(res => {
      this.day = {...res.body.data}
    })
    this.dayList = this.yearList,
        getWorkInfo({type: 2}).then(res => {
          this.week = {...res.body.data}
        })
    this.weekList = this.yearList,
        getWorkInfo({type: 3}).then(res => {
          this.month = {...res.body.data}
          this.monthList = this.monthList
        })
    getWorkInfo({type: 4}).then(res => {
      this.year = {...res.body.data}
    })
    this.yearList = this.yearList*/
    qualifiedStatistics({type: 4}).then(res => {
      this.year = {...res.body.data}
    })
    this.getWorkInfo();
  },
  methods: {
    gmtCreate(e) {
      console.log(e)
      if (e && e.length) {
        this.queryParams.planStartTime = e[0];
        this.queryParams.planEndTime = e[1];
      }
    },
    onSearch() {
      this.getWorkInfo();
    },
    resetSearch() {
      this.getWorkInfo();
    },
    getWorkInfo(){
      const params = {
        "planStartTime": this.queryParams.planStartTime,
        "planEndTime": this.queryParams.planEndTime,
      };
      getWorkInfo(params).then(res => {
        if (res.body.data != null){
          this.yearList = res.body.data
        }
      })
    }
  }
}
</script>

<style scoped>
.bodyBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.cardBox {
  width: 49.5%;
  height: 670px;
  margin-bottom: 10px;
  background: white;
}

.cardHead {
  padding: 15px 24px 0 24px;
  color: (0, 0, 0, .85);
  font-size: 16px;
  font-weight: 500;
}

.el-divider {
  margin: 15px 0
}

.cardBox /deep/ .el-card__body {
  height: 85px;
}

.cardBox h2 {
  color: rgba(0, 0, 0, .85);
}
</style>